import React from 'react'
import clientData from 'utils/client-data'
import glamorous from 'glamorous'
import { css } from 'glamor'
import {
  HeadingText,
  BodyText,
  ChevronRightIcon,
  white,
  Link,
  grey300,
  grey500,
  v2grey600,
} from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
import EditBackground from './shared/edit-background'
const l10n = getContent('pages/seller/settings')

const Container = glamorous.div({
  margin: '-30px 0 0 0',
  fontSize: '1rem',
  '& div[role=heading]': {
    textAlign: 'center',
    position: 'absolute',
    width: '100%',
    top: -85,
  },
})

const Heading = css({
  position: 'absolute',
  top: -42,
  left: '50%',
  transform: 'translate(-50%, -50%)',
})

const title = css({
  marginTop: 350,
  '@media(max-width: 640px)': {
    marginTop: 300,
  },
  '@media(max-width: 480px)': {
    marginTop: 260,
  },
})

const EditItem = glamorous.div(
  {
    position: 'relative',
    margin: '16px 0',
    width: '100%',
    cursor: 'pointer',
  },
  ({ noEdit }) =>
    noEdit && {
      cursor: 'default',
    },
)

const editLabel = css({
  fontSize: '0.875rem',
  color: v2grey600,
})

const editValue = css({
  width: 'calc(100% - 40px)',
  marginTop: 2,
})

const socialMediaText = css({
  marginTop: 0,
})

const rightArrow = css({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
})

const noPadding = css({
  padding: 0,
})

const customMargin = css({
  margin: '1rem 0',
  padding: 0,
})

const DottedSeparater = glamorous.div({
  backgroundImage: `linear-gradient(to right, ${grey500} 10%, ${white} 5%)`,
  backgroundPosition: 'top',
  backgroundSize: '7px 1px',
  backgroundRepeat: 'repeat-x',
  height: 1,
  marginTop: 16,
})

const Separater = glamorous.div({
  width: '116%',
  height: 1,
  borderBottom: `1px solid ${grey300}`,
  margin: '26px 0',
  transform: 'translateX(-8%)',
})

function SellerSettings(props) {
  const {
    sellerProfileState: {
      state: {
        sellerProfileDetails: {
          id: businessHandle = '',
          status = 'INACTIVE',
          user_info: {
            alternate_full_name: businessName = '',
            display_email: email = '',
            display_mobile_phone: phone = '',
            display_address: businessLocation = '',
            profile_photo_url: profilePhotoUrl = '',
          } = {},
          personalization_settings: {
            cover_photo_url: coverPhotoUrl = '',
            description = '',
          } = {},
          privacy_settings: {
            phone_search_enabled: phoneSearchEnabled = false,
            email_search_enabled: emailSearchEnabled = false,
          } = {},
        } = {},
      } = {},
    } = {},
  } = props
  const { isMobile } = clientData
  const profileStatus = status === 'ACTIVE'

  const businessMap = [
    {
      label: l10n('businessName'),
      value: businessName,
      onClick: (e) => {
        e.preventDefault()
        props.history.push(`/seller/${businessHandle}/settings/name`)
      },
    },
    {
      label: l10n('businessHandle'),
      value: `@${businessHandle}`,
      onClick: () => {},
    },
    {
      label: l10n('description'),
      value: description,
      onClick: (e) => {
        e.preventDefault()
        props.history.push(`/seller/${businessHandle}/settings/description`)
      },
    },
  ]

  const contactDetailsMap = [
    {
      label: l10n('phone'),
      value: phoneSearchEnabled
        ? phone
        : l10n('edit.phone.option.hide', { phone }),
      onClick: (e) => {
        e.preventDefault()
        props.history.push(`/seller/${businessHandle}/settings/phone`)
      },
    },
    {
      label: l10n('email'),
      value: emailSearchEnabled
        ? email
        : l10n('edit.email.option.hide', { email }),
      onClick: (e) => {
        e.preventDefault()
        props.history.push(`/seller/${businessHandle}/settings/email`)
      },
    },
    {
      label: l10n('businessLocation'),
      value: businessLocation
        ? businessLocation
        : l10n('edit.location.option.none'),
      onClick: (e) => {
        e.preventDefault()
        props.history.push(`/seller/${businessHandle}/settings/location`)
      },
    },
  ]

  const onEditProfileStatus = (e) => {
    e.preventDefault()
    props.history.push(`/seller/${businessHandle}/settings/profile`)
  }

  const onEditSocialMedia = (e) => {
    e.preventDefault()
    props.history.push(`/seller/${businessHandle}/settings/social`)
  }

  const redirectToSearchPrivacy = () => {
    /* TODO: Update links */
    window.open('https://www.paypal.com', '_blank')
  }

  return (
    <Container>
      {isMobile ? (
        <BodyText className={`${Heading}`} strong>
          {l10n('editProfile')}
        </BodyText>
      ) : (
        <HeadingText size="sm" className={`${Heading}`}>
          {l10n('editProfile')}
        </HeadingText>
      )}
      <EditBackground {...{ profilePhotoUrl, coverPhotoUrl }} />
      <BodyText strong className={`${title}`}>
        {l10n('profileDetails')}
      </BodyText>
      {profileStatus
        ? businessMap.map((item, i) => {
            return (
              <EditItem key={i} onClick={item.onClick} noEdit={i === 1}>
                <BodyText className={`${editLabel}`}>{item.label}</BodyText>
                <BodyText className={`${editValue}`}>{item.value}</BodyText>
                {i !== 1 ? (
                  <ChevronRightIcon size="sm" className={`${rightArrow}`} />
                ) : null}
                <DottedSeparater />
              </EditItem>
            )
          })
        : null}
      <EditItem onClick={onEditProfileStatus}>
        <BodyText strong>{`${l10n('profileStatus')} ${
          profileStatus ? l10n('On') : l10n('Off')
        }`}</BodyText>
        <BodyText className={`${editValue}`}>
          {profileStatus
            ? l10n('edit.status.option.onText')
            : l10n('edit.status.option.offText')}
        </BodyText>
        <ChevronRightIcon size="sm" className={`${rightArrow}`} />
        {profileStatus ? <DottedSeparater /> : null}
      </EditItem>
      {profileStatus ? (
        <>
          <EditItem onClick={redirectToSearchPrivacy}>
            <BodyText strong>{l10n('searchPrivacy')}</BodyText>
            <BodyText className={`${editValue}`}>
              {l10n('searchPrivacyText')}
            </BodyText>
            <ChevronRightIcon size="sm" className={`${rightArrow}`} />
          </EditItem>
          <Separater />
          <BodyText>
            {/* TODO: Update links */}
            {l10n('primaryAccountInfo', {
              primaryAccountLink: (
                <Link to="/my/profile">{l10n('primaryAccountSettings')}</Link>
              ),
            })}
          </BodyText>
        </>
      ) : null}
      {profileStatus
        ? contactDetailsMap.map((item, i) => {
            return (
              <EditItem
                key={i}
                className={`${i === 2 ? customMargin : ''}`}
                onClick={item.onClick}
              >
                <BodyText className={`${editLabel}`}>{item.label}</BodyText>
                <BodyText className={`${editValue}`}>{item.value}</BodyText>
                <ChevronRightIcon size="sm" className={`${rightArrow}`} />
                {i !== 2 ? <DottedSeparater /> : null}
              </EditItem>
            )
          })
        : null}
      {profileStatus ? (
        <>
          <Separater />
          <EditItem className={`${noPadding}`} onClick={onEditSocialMedia}>
            <BodyText strong className={`${socialMediaText}`}>
              {l10n('socialMedia')}
            </BodyText>
            <ChevronRightIcon size="sm" className={`${rightArrow}`} />
          </EditItem>
          <Separater />
        </>
      ) : null}
    </Container>
  )
}

export default SellerSettings
